import React from "react";
import styles from "./TableCard.module.scss";

/**
 * TableCard — token-driven tablo kart primitive'i.
 *
 * Kullanım:
 *   <TableCard leftSlot={...} rightSlot={...}>
 *     <DataTable ... />
 *     <Pager ... />
 *   </TableCard>
 *
 * Sözleşme: dış border yok (yalnız yumuşak gölge), header alt çizgisi yok
 * (docs/DESIGN.md + Faz 8 review). Eski Reactstrap Card/CardHeader/CardBody
 * sözleşmesi söküldü.
 */
export default function TableCard({
  leftSlot,
  rightSlot,
  children,
  className,
  variant,
}) {
  const variantClass = variant ? `de-table-card--${variant}` : "";

  return (
    <article
      className={[
        styles["table-card"],
        "de-table-card",
        variantClass,
        className || null,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {(leftSlot || rightSlot) && (
        <header className={styles["table-card__toolbar"]}>
          <div className={styles["table-card__toolbar-side"]}>{leftSlot}</div>
          <div className={styles["table-card__toolbar-side"]}>{rightSlot}</div>
        </header>
      )}
      <div className={styles["table-card__body"]}>{children}</div>
    </article>
  );
}
